import * as React from 'react';

// Top navigation for family-facing pages.

export const TopNav = ({ go, route, transparent }) => {
  const [scrolled, setScrolled] = React.useState(false);
  React.useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 32);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const showSolid = !transparent || scrolled;

  return (
    <header className={`site-header ${showSolid ? 'is-solid' : ''}`}>
      <div className="container nav-wrap">
        <button
          onClick={() => go('home')}
          className="brand-link"
        >
          <img
            src="/assets/logo.png" alt=""
            className="brand-logo"
          />
          <span className="brand-wordmark">
            Find My Childcare
          </span>
        </button>
        <nav className="public-nav" aria-label="Primary">
          <button
            className={route === 'results' ? 'is-active' : ''}
            onClick={() => go('results')}
          >
            Find care
          </button>
          <button
            className={route === 'requests' ? 'is-active' : ''}
            onClick={() => go('requests')}
          >
            My requests
          </button>
          <button
            className={route === 'resources' ? 'is-active' : ''}
            onClick={() => go('resources')}
          >
            Child Care Works
          </button>
        </nav>
      </div>
    </header>
  );
};
